import { render } from "./enrolments.vue?vue&type=template&id=01922444&scoped=true"
import script from "./enrolments.vue?vue&type=script&lang=js"
export * from "./enrolments.vue?vue&type=script&lang=js"

import "./enrolments.vue?vue&type=style&index=0&id=01922444&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01922444"]])

export default __exports__